module.exports = __webpack_public_path__ + "img/gmailLogo.bf2fec10.svg";